import React from 'react'

// https://emoji.aranja.com/

export type EmojiName =
  | 'coffee'
  | 'crescent_moon'
  | 'electric_plug'
  | 'lock'
  | 'mag'
  | 'seedling'
  | 'sparkles'
  | 'star'
  | 'truck'
  | 'wave'
  | 'white_check_mark'
  | 'tada'

interface EmojiProps {
  name: EmojiName
  style?: object
}

const Emoji = React.forwardRef((props: EmojiProps, ref: any) => {
  const { name, style } = props

  return (
    <img
      ref={ref}
      src={`/assets/emojis/${name}.png`}
      style={{
        height: '1em',
        verticalAlign: 'baseline',
        width: '1em',
        ...style
      }}
    />
  )
})

Emoji.displayName = 'Emoji'
export default Emoji
